window.themeLoadScript = window.themeLoadScript || function (scriptId, src, attributes) {
  var existingScript = document.getElementById(scriptId);

  if (existingScript) {
    if (existingScript.dataset.loaded === 'true') {
      return Promise.resolve(existingScript);
    }

    return new Promise(function (resolve, reject) {
      existingScript.addEventListener('load', function () {
        existingScript.dataset.loaded = 'true';
        resolve(existingScript);
      }, { once: true });
      existingScript.addEventListener('error', reject, { once: true });
    });
  }

  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    var attrMap = attributes || {};

    script.id = scriptId;
    script.src = src;
    script.async = true;

    Object.keys(attrMap).forEach(function (key) {
      script.setAttribute(key, attrMap[key]);
    });

    script.addEventListener('load', function () {
      script.dataset.loaded = 'true';
      resolve(script);
    }, { once: true });
    script.addEventListener('error', reject, { once: true });

    document.head.appendChild(script);
  });
};

(function () {
  function initPopupStackingFix() {
    var popup = document.getElementById('successPopup');
    var myPayPopup = document.querySelector('.mypay-checkout-confirm-popup');

    if (!popup && !myPayPopup) return;

    var header = document.querySelector('.shopify-section.shopify-section-group-header-group.section-header');
    var swiperDiv = document.querySelector('.swiper.grid-scroll.d-block.pos-relative.no-js-overflow-x.swiper-initialized.swiper-horizontal.swiper-watch-progress.swiper-backface-hidden');

    function updateZIndex() {
      if (popup) {
        var popupDisplay = window.getComputedStyle(popup).display;

        if (popupDisplay === 'flex') {
          if (header) header.style.zIndex = '0';
          if (swiperDiv) swiperDiv.style.zIndex = '0';
        } else {
          if (header) header.style.zIndex = '2';
          if (swiperDiv) swiperDiv.style.zIndex = '';
        }
      }

      if (myPayPopup) {
        var myPayDisplay = window.getComputedStyle(myPayPopup).display;

        if (myPayDisplay === 'flex') {
          if (header) header.style.zIndex = 'auto';
        } else if (!popup || window.getComputedStyle(popup).display !== 'flex') {
          if (header) header.style.zIndex = '2';
        }
      }
    }

    updateZIndex();

    [popup, myPayPopup].forEach(function (node) {
      if (!node) return;

      var observer = new MutationObserver(updateZIndex);
      observer.observe(node, { attributes: true, attributeFilter: ['style', 'class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopupStackingFix, { once: true });
  } else {
    initPopupStackingFix();
  }
})();
